module.exports = __webpack_public_path__ + "img/input-tooltip.b67b99cc.svg";